import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';
import { startSwUpdate } from './cashier/pwa/swUpdate';

/**
 * PWA 启动段（`05-ui-design-system.md` §5.6）。
 *
 * **这里是全应用唯一的 `registerSW` 调用点**，两件事都在它身上：
 *   ① 注册 Service Worker（`injectRegister: 'auto'` 的语义是「应用自己 import 了
 *      `virtual:pwa-register` 就不再自动注入 `registerSW.js`」⇒ 删掉这一行 = 真产物没有 SW 注册，
 *      PWA 装到桌面也永远停在旧版）；
 *   ② 把「SW 进入 `waiting`」接成一条 window 事件（`startSwUpdate` 里的 `onNeedRefresh`），
 *      由收银端外壳里的 `useSwUpdate` 订阅后渲染 `sw-update-toast`。
 *
 * ⚠️ `virtual:pwa-register` 只在**构建期**存在（jsdom 里解析不了）⇒ 只有这一个文件静态引用它。
 * 收银端外壳被六个 spec 引用，把那个 import 放进外壳的模块图里会让它们一起在收集阶段炸掉
 * （见 `cashier/pwa/swUpdate.ts` 的说明）。
 *
 * 「启动时的版本比对」在 `useSwUpdate` 里（它需要 React 状态去渲染提示），由 `/cashier` 外壳在
 * 挂载时执行 —— 而 `/cashier` 正是本 PWA 的 `start_url`。
 */
startSwUpdate(registerSW);

const container = document.getElementById('root');
if (!container) throw new Error('#root 未找到');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
